export class MaxValuesComparisonModel {
    MaxAskingPrice: number = 0;
    MaxAcquisitionPrice: number = 0;
    MaxNOI: number = 0;
    MaxCapRate: number = 0;
    MaxReturnDuringPrice: number = 0;
    MaxRentEscalationPercentage: number = 0;
    MaxRemainingTerm: number = 0;
    MaxBuildingSize: number = 0;
    MaxLand: number = 0;
    MaxYearBuilt: number = 0;
}
